import { Eventing } from '@candulabs/eventing';
import { useCanduContext } from '../components/CanduProviderContext';

export const useEventing: () => Eventing = () => useCanduContext().eventing;
